import { FC } from 'react';
import { Props } from './types';
import WatermarkStyled from './style';

const Watermark: FC<Props & { children?: any }> = ({ id, show, children, ...restProps }) => {
  if (show) {
    return (
      <WatermarkStyled id={id} {...restProps}>
        {children}
      </WatermarkStyled>
    );
  }
  return null;
};

export default Watermark;
